<template>
  <div>
    <list row-key="id" ref="list" unit="订单" :page="page" :query-params="params" :show-query="showQuery"
      :get-data-func="getDataFunc" max-height="550px">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" plain @click="exportExcel">导出回传 Excel</el-button>
        <el-button type="success" @click="importExcel">回传 Excel</el-button>
      </template>
      <template slot="query">
        <el-form-item label="订单编号" label-width="105px">
          <el-input v-model="params.orderSn" placeholder="请输入订单编号" clearable />
        </el-form-item>
        <el-form-item label="下单时间" label-width="105px">
          <range-picker :date="[params.startDate, params.endDate]"
            @change="x => { params.startDate = x.Start; params.endDate = x.End; }" />
        </el-form-item>
        <el-form-item label="订单状态" label-width="105px">
          <el-select v-model="params.orderStatusDesc" placeholder="请选择" clearable>
            <el-option label="等待买家付款" value="等待买家付款"></el-option>
            <el-option label="等待卖家发货" value="等待卖家发货"></el-option>
            <el-option label="等待物流公司揽件" value="等待物流公司揽件"></el-option>
            <el-option label="等待买家收货" value="等待买家收货"></el-option>
            <el-option label="等待买家签收" value="等待买家签收"></el-option>
            <el-option label="买家已签收" value="买家已签收"></el-option>
            <el-option label="已收货" value="已收货"></el-option>
            <el-option label="交易成功" value="交易成功"></el-option>
            <el-option label="交易取消" value="交易取消"></el-option>
            <el-option label="交易终止" value="交易终止"></el-option>
            <el-option label="已收货待到账" value="已收货待到账"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="aliMallMallName" label="店铺名称" min-width="150px" />
        <el-table-column prop="province" label="省份" min-width="150px" />
        <el-table-column prop="city" label="城市" min-width="150px" show-overflow-tooltip />
        <el-table-column prop="District" label="区县" min-width="120px" show-overflow-tooltip />
        <el-table-column prop="town" label="街道" min-width="120px" show-overflow-tooltip />
        <el-table-column prop="receiverName" label="收货人" min-width="80px" />
        <el-table-column prop="receiverPhone" label="收货电话" min-width="110px" />
        <el-table-column prop="address" label="收货地址" min-width="300px" show-overflow-tooltip />
        <el-table-column prop="buyer" label="下单人名称" min-width="100px" />
        <el-table-column prop="buyerMemo" label="下单备注" min-width="400px" />
        <el-table-column prop="discountAmount" label="折扣金额" min-width="100px" />
        <el-table-column prop="expressName" label="物流公司名称" min-width="180px" />
        <el-table-column prop="logisticsId" label="物流ID" min-width="150px" />
        <el-table-column prop="expressNumber" label="物流单号" min-width="160px" />
        <el-table-column prop="lastShipTime" label="发货时间" min-width="160px" />
        <el-table-column prop="goodsCount" label="商品数量" min-width="80px" />
        <el-table-column prop="goodsId" label="商品ID" min-width="130px" />
        <el-table-column prop="categoryName" label="类目名称" min-width="130px" />
        <el-table-column prop="goodsImageUrl" label="商品图片" min-width="110px" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 80px;height: 80px;" :src="row.goodsImageUrl"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="orderSn" label="订单编号" min-width="180px" />
        <el-table-column prop="orderStatusDesc" label="订单状态" min-width="150px" />
        <el-table-column prop="orderTime" label="订单时间" min-width="160px" />
        <el-table-column prop="payAmount" label="付款金额" min-width="100px" />
        <el-table-column prop="payTime" label="支付时间" min-width="160px" />
        <el-table-column prop="shippingAmount" label="运费" min-width="80px" />
        <el-table-column prop="skuId" label="SkuID" min-width="140px" />
        <el-table-column prop="uid" label="下单用户ID" min-width="160px" />
        <el-table-column prop="afterSalesCreateTime" label="售后创建时间" min-width="160px" />
        <el-table-column prop="afterSalesStatus" label="售后状态" min-width="100px" />
        <el-table-column prop="afterSaleReason" label="售后原因" min-width="300px" show-overflow-tooltip />
        <el-table-column prop="refundFree" label="退款金额" min-width="80px" />
        <el-table-column prop="refundFinishTime" label="售后结束时间" min-width="160px" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import importDialog from "./importDialog"

export default {
  mixins: [listMixin],
  components: { list, importDialog },
  data() {
    return {
      api: require('@/api/wx/order').default,
      params: {
        orderSn: "", // 订单编号
        startDate: null, // 下单时间
        endDate: null,
        orderStatusDesc: null, // 订单状态
        isRefund: false, // 是否售后订单
        isShipped: true
      },
    };
  },
  created() { },
  methods: {
    onTest() {
      this.api.test()
    },
    getDataFunc(params) {
      params = this.$commonJs.obj.removeNullKey(params);
      return new Promise((resolve, reject) => {
        console.log("获取数据", params);
        this.api.getOrders(params).then(res => {
          console.log("getDataFunc", res);
          resolve({ code: 0, data: res.data, count: res.count, msg: null });
        }).catch(err => {
          reject(err);
        })
      })
    },
    //订单导出
    exportExcel() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.getOrders(params).then(res => {
        if (res && res.data) {
          var list = res.data.map(x => {
            return {
              orderSn: x.orderSn,
              expressNumber: "",
            }
          });
          if (list.length > 0) {
            var item = list[0];
            var keys = Object.keys(item);

            console.log("订单导出", keys);
            console.log("订单导出", list);
            import('@/vendor/Export2Excel').then(excel => {
              const tHeader = ['订单编号', '物流单号'];
              const filterVal = keys;
              excel.export_json_to_excel({
                header: tHeader,
                data: this.formatJson(filterVal, list),
                filename: "导出回传_" + this.$commonJs.toDateStringByFormat(new Date, "YYYYMMDDHHmmss"),
              })
              loading.close();
            })
          } else {
            this.$message.error("没有数据可以导出")
            loading.close();
          }
        } else {
          this.$message.error("获取数据失败")
          loading.close();
        }
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    },
    importExcel() {
      this.$refs.importDialog.open();
    }
  },
};
</script>